export function getMostFrequentString<T>(arr: T[]) {
  const map = new Map();
  let maxCount = 0;
  let maxStr = arr[0];

  arr.forEach((str) => {
    const count = (map.get(str) || 0) + 1;
    map.set(str, count);

    if (count > maxCount) {
      maxCount = count;
      maxStr = str;
    }
  });

  return maxStr;
}
